import React, { useEffect, useMemo, useState } from 'react';
import { exportExcel } from '../../../../utils/exportExcel';
import { enumTipoParticipante, TipoFuncionalidad } from '../../../../utils/enums';
import { useDeudor } from '../../hooks/useDeudor';
import { columns } from "../../../../dtos/columns";
import { numericFormatter } from 'react-number-format';
import { useCodeudor } from '../../hooks/useCodeudor';
import AccionesGrillaSeguros from './accionesGrillaSeguros';
import { SeguroDeudorEdit } from '../../models/seguroDeudorEdit';
import { SeguroCodeudorEdit } from '../../models/seguroCodeudorEdit';
import SeguroDeudorForm from './seguroDeudorForm';
import Tabla from '../../../../components/ui/materialui/tabla';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone'
import { Grid2 } from '@mui/material';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';
interface IProps {
    idMutuo: number;
    rut: string;
    tipoParticipante: enumTipoParticipante;
    porcentajedeudaseguro: number;
    tipoDeudor: string;
    isDesactivado?: boolean
    esVigente: boolean;

}

export interface SeguroRow {
    TipoParticipante: enumTipoParticipante;
    MutuoId: number;
    SeguroId?: number | undefined;
    RutAsegurado?: string | undefined;
    TipoSeguro: string;
    CodigoPoliza: string;
    CodigoHijo?: string;
    CompaniaSeguros?: string | undefined;
    Descripcion: string | null | undefined;
    Tasa: number;
    MontoPrimaAnual: number;
    MontoAsegurado: number;
    MontoPrimaDividendo: number;
    TieneCuotaMinima?: boolean;
    MesesGracias?: number;
}

const ListaSeguros: React.FC<IProps> = (props) => {

    const { obtenerSegurosDeudor, defaultValues } = useDeudor();
    const { obtenerSegurosCodeudor } = useCodeudor();
    const [segurosRows, setSegurosRows] = useState<SeguroRow[]>([]);
    const [seguroDeudorSeleccionado, setSeguroDeudorSeleccionado] = useState<SeguroDeudorEdit>();
    const [seguroCodeudorSeleccionado, setSeguroCodeudorSeleccionado] = useState<SeguroCodeudorEdit>();
    const [tipoSeguroSeleccionado, setTipoSeguroSeleccionado] = useState<enumTipoParticipante>();
    const [show, setShow] = useState<boolean>(false);
    const [esNuevo, setEsNuevo] = useState<boolean>(false);

    const segurosDeudor = async () => {
        const resp = await obtenerSegurosDeudor(props.idMutuo)
        if (!resp) return;

        const dataRowMapping: SeguroRow[] = resp.map(seguro => ({
            TipoParticipante: enumTipoParticipante.Deudor,
            MutuoId: props.idMutuo,
            SeguroId: seguro.seguroId,
            TipoSeguro: seguro.tipoSeguro,
            CodigoPoliza: seguro.codigoPoliza,
            CompaniaSeguros: seguro.companiaSeguros,
            Descripcion: seguro.descripcion,
            Tasa: seguro.tasa,
            MontoPrimaAnual: seguro.montoPrimaAnual,
            MontoAsegurado: seguro.montoAsegurado,
            MontoPrimaDividendo: seguro.montoPrimaDividendo,
            MesesGracias: seguro.mesesGracias,
            TieneCuotaMinima: seguro.tieneCuotaMinima,
            CodigoHijo: seguro.codigoHijo
        }));

        setSegurosRows(dataRowMapping);
    }

    const COLUMNS: columns<SeguroRow>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            sortable: true,
            wrap: true,
            export: false,
            cell: (row) => <AccionesGrillaSeguros
                seguroRow={row}
                setTipoSeguroSeleccionado={setTipoSeguroSeleccionado}
                setSeguroDeudorSeleccionado={setSeguroDeudorSeleccionado}
                setSeguroCodeudorSeleccionado={setSeguroCodeudorSeleccionado}
                setShow={setShow}
                renderizar={segurosDeudor}
                esVigente={props.esVigente}
            />,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Tipo seguro',
            selector: (row) => row.TipoSeguro,
            sortable: true,
            sortField: 'TipoSeguro',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Código poliza',
            selector: (row) => row.CodigoPoliza,
            sortable: true,
            sortField: 'CodigoPoliza',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Compañía de seguros',
            selector: (row) => row.CompaniaSeguros,
            sortable: true,
            sortField: 'CompaniaSeguros',
            wrap: true,
            export: true,
            center: false,
        },
        {
            name: 'Descripción',
            selector: (row) => row.Descripcion,
            sortable: true,
            sortField: 'Descripcion',
            wrap: true,
            export: true,
            center: false,
        },
        {
            name: 'Tasa',
            selector: (row) => row.Tasa,
            cell: (row) => numericFormatter(row.Tasa.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": " %" }),
            sortable: true,
            sortField: 'Tasa',
            wrap: true,
            export: true,
            right: true,
        },
        {
            name: 'Prima anual',
            selector: (row) => row.MontoPrimaAnual,
            cell: (row) => numericFormatter(row.MontoPrimaAnual.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'MontoPrimaAnual',
            wrap: true,
            export: true,
            right: true,
        },
        {
            name: 'Monto asegurado',
            selector: (row) => row.MontoAsegurado,
            cell: (row) => numericFormatter(row.MontoAsegurado.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'MontoAsegurado',
            wrap: true,
            export: true,
            right: true,
        },
        {
            name: 'Prima dividendo',
            selector: (row) => row.MontoPrimaDividendo,
            cell: (row) => numericFormatter(row.MontoPrimaDividendo.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'MontoPrimaDividendo',
            wrap: true,
            export: true,
            right: true,
        },
    ];

    const columns = useMemo(() => COLUMNS, [segurosRows, props.esVigente]);

    useEffect(() => {

        if (props.tipoParticipante == enumTipoParticipante.Deudor) {
            segurosDeudor();
        }

        if (props.tipoParticipante == enumTipoParticipante.Codeudor) {

            obtenerSegurosCodeudor(props.idMutuo, props.rut)
                .then((seguros) => {

                    const dataRowMapping: SeguroRow[] = seguros.map(seguro => ({
                        TipoParticipante: enumTipoParticipante.Codeudor,
                        MutuoId: props.idMutuo,
                        RutAsegurado: seguro.rut,
                        TipoSeguro: seguro.tipoSeguro,
                        CodigoPoliza: seguro.codigoPoliza,
                        CompaniaSeguros: seguro.companiaSeguros,
                        Descripcion: seguro.descripcion,
                        Tasa: seguro.tasa,
                        MontoPrimaAnual: seguro.montoPrimaAnual,
                        MontoAsegurado: seguro.montoAsegurado,
                        MontoPrimaDividendo: seguro.montoPrimaDividendo,
                    }));

                    setSegurosRows(dataRowMapping);

                });
        }

    }, [props.idMutuo])

    const handleNuevoSeguro = () => {
        setSeguroDeudorSeleccionado(defaultValues);
        setShow(true);
        setEsNuevo(true)
    }

    const onHideModal = () => {
        setShow(false);
        setSeguroDeudorSeleccionado(undefined);
        setEsNuevo(false);
    }

    return (
        <>
            <Grid2 sx={{ mb: 3, mt: 2 }}>
                <Tabla
                    columns={columns}
                    data={segurosRows}
                    titulo={<TableHeader
                        // title="Seguros asociados"
                        button={(
                            <DetalleMutuoPermissionGuard
                                esVigente={props.esVigente}
                                permissions={[TipoFuncionalidad.Bandeja_editar]}>
                                <MButton
                                    type='button'
                                    variant="contained"
                                    onClick={handleNuevoSeguro}
                                    disabled={props.isDesactivado}
                                    startIcon={<AddTwoToneIcon />}
                                >
                                    Agregar
                                </MButton>
                            </DetalleMutuoPermissionGuard>
                        )}
                        buttonExport={
                            <>
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                    <MButton
                                        type="button"
                                        variant="outlined"
                                        onClick={() => exportExcel(segurosRows, columns, "Listado-Seguros")}
                                        startIcon={<SummarizeTwoToneIcon />}
                                    >
                                        Exportar
                                    </MButton>
                                </PermissionGuard>

                            </>
                        }
                    />}
                />
            </Grid2>

            {
                (seguroDeudorSeleccionado) &&
                <Grid2>
                    <SeguroDeudorForm
                        seguroDeudorEdit={seguroDeudorSeleccionado}
                        showModal={show}
                        onHideModal={onHideModal}
                        datosEditar={!esNuevo}
                        segurosRows={segurosRows}
                        render={segurosDeudor}
                        idMutuo={props.idMutuo}
                        esVigente={props.esVigente}
                    ></SeguroDeudorForm>
                </Grid2>
            }
        </>
    );
};

export default ListaSeguros;


